var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M0 150.069v211.862L141.241 256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.621 88.276l158.897 123.586H512V97.103a8.829 8.829 0 0 0-8.828-8.828H70.621v.001z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.621 423.724l158.897-123.586H512v114.759a8.829 8.829 0 0 1-8.828 8.828H70.621v-.001z",
    fill: "#41479b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.889 88.276H8.828A8.828 8.828 0 0 0 0 97.103v36.21L154.974 256 0 378.69v36.206a8.829 8.829 0 0 0 8.828 8.828h48.056L224.147 291.31H512v-70.62H224.148L56.889 88.276z",
    fill: "#73af00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M85.333 88.276H56.889L224.148 220.69H512v-17.656H230.291z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M0 133.313v22.518L126.53 256 0 356.173v22.517L154.974 256z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M224.147 291.31L56.884 423.724h28.445l144.96-114.758H512V291.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.7a643b1553658d758be21b7ab3fe88dd.svg";
export { ForwardRef as ReactComponent };